module.exports = __webpack_public_path__ + "static/img/caihongwoniu.91047c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/caihongwoniu.png
// module id = 6GCo
// module chunks = 1